export default import.meta.ROLLDOWN_FILE_URL_OestAvA2SyLT4CG6L76dAw